<script setup lang="ts">
import { useRoute } from "vue-router";
import { computed, defineComponent } from "vue";

import SnackbarComponent from "@/components/ui/SnackbarComponent.vue";

defineComponent([SnackbarComponent]);

const route = useRoute();

const layout = computed(() => route.meta.layout || "div");

</script>

<template>
  <component :is="layout">
    <router-view />
  </component>
  <SnackbarComponent />
</template>
